import { defineComponent, ref } from "vue";
import { showNotify } from "vant";
import { upload } from "@/api/upload";
import Compressor from "compressorjs";
export default defineComponent({
  name: "Recharge",
  props: {
    maxSize: {
      type: [String, Number],
      default: 10
    }
  },
  setup(props, context) {
    let fileList = ref([]);
    const beforeRead = async file => {
      await new Promise(resolve => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          success: resolve,
          error(err) {
            console.log(err.message);
          }
        });
      });
    };
    const onOversize = file => {
      showNotify({
        type: "warning",
        message: `上传图片大小不能超过${props.maxSize}M`
      });
    };
    const afterRead = file => {
      // 此时可以自行将文件上传至服务器
      file.status = "uploading";
      file.message = "上传中...";
      upload({
        file: file.file
      }).then(({
        data: {
          code,
          msg,
          data
        }
      }) => {
        if (code !== 200) {
          file.status = "failed";
          file.message = "上传失败";
          fileList.value = [];
          return showNotify({
            type: "warning",
            message: msg
          });
        }
        file.status = "done";
        context.emit("change", data.fileName);
        context.emit("file", {
          ...file,
          url: data.url
        });
      }).catch(err => {
        file.status = "failed";
        file.message = "上传失败";
        showNotify({
          type: "warning",
          message: err.msg
        });
      });
    };
    const setData = res => {
      fileList.value = res;
    };
    return {
      props,
      fileList,
      setData,
      beforeRead,
      onOversize,
      afterRead
    };
  }
});